import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
// Icon
import WorkIcon from '@mui/icons-material/Work';
import DeleteIcon from '@mui/icons-material/Delete'
import { useListaCboService } from "../../../../../../../use-cases/geo-veles/lista-cbo";

export const RecorteCboFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Hook
    const { removeFilterFromForm } = useRecortesExtracaoService()
    const { setupListasCbo } = useListaCboService()

    const cboSelecionado = createRecorteExtracaoForm.fields.Filtros?.cbo
        ? createRecorteExtracaoForm.fields.Filtros?.cbo
        : []

    const handleRemoveFilter = () => {
        removeFilterFromForm({
            filtro: 'cbo',
            formType: 'create'
        })
        setupListasCbo()
    }

    return (
        <Grid item container xs={6} spacing={2} mb={2}>
            <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                    <Grid item>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mr={2}
                        >
                             CBO
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={handleRemoveFilter}
                        >
                            Remover filtro
                        </Button>
                    </Grid>
                </Grid>

                {cboSelecionado.length > 0 && (
                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {cboSelecionado.map((cbo, i) => (
                                <Chip
                                    key={i}
                                    icon={<WorkIcon/>}
                                    label={cbo.cbocodigo?.toUpperCase() + ' - ' + cbo.cbodescricao}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                )}
            </Paper>
        </Grid>
    )
}